import { useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { format } from "date-fns";
import CustomCollapsible from "../CustomCollapsible";
import CustomDatePickerModal from "../CustomDatePickerModal";
import { ChevronDown, ChevronUp } from "../../assets/svgs";

import "./styles.scss";

const DatePickerInput = ({ label = "preferred_payment_date" }) => {
  const location = useLocation();
  const { t } = useTranslation();

  const [selectedDate, setSelectedDate] = useState("");
  const [showDatePicker, setShowDatePicker] = useState(false);

  const { pathname } = location;
  const routeName = pathname.split("/")[1];

  const formattedDate = useMemo(() => {
    if (!selectedDate) return "";
    return format(new Date(selectedDate), "dd LLL yyyy");
  }, [selectedDate]);

  return (
    <>
      <CustomCollapsible
        cardHeading={t(`${routeName}.${label}`)}
        open={true}
        collapsibleWrapperClasses="date-picker-wrapper"
        openedIcon={ChevronUp}
        closedIcon={ChevronDown}
      >
        <div
          className="date-display-text"
          onClick={() => setShowDatePicker(true)}
        >
          {formattedDate || t("global.select_a_date")}
        </div>
      </CustomCollapsible>
      <CustomDatePickerModal
        visible={showDatePicker}
        onClickBackdrop={() => setShowDatePicker(false)}
        selected={selectedDate}
        onSelect={date => {
          setSelectedDate(date);
          setShowDatePicker(false);
        }}
        disabled={{ before: new Date() }}
      />
    </>
  );
};

export default DatePickerInput;
